<template>
  <div>
    <v-row dense>
      <v-col v-if="!settings.new_time_changes" cols="12" md="6" class="d-flex">
        <v-switch
          @click="switchTimeStatus('new')"
          v-model="settings.new_time_changes"
          inset
        />
        <p class="text-body-2 mb-0">
          {{ $t("new_time_changes") }}
        </p>
      </v-col>
      <v-col cols="12">
        <p class="text-subtitle-2 mb-2">
          {{ $t("order_dead_line") }}
        </p>
      </v-col>
    </v-row>

    <v-row dense v-if="settings.new_time_changes" class="mb-4">
      <v-col cols="12">
        <v-row dense class="time-header mb-2">
          <v-col cols="12" md="2" class="text-caption text--secondary">
            {{ $t("day") }}
          </v-col>
          <v-col cols="12" md="3" class="text-caption text--secondary">
            {{ $t("day_before_limit") }}
          </v-col>
          <v-col cols="12" md="3" class="text-caption text--secondary">
            {{ $t("time") }}
          </v-col>
          <v-col cols="12" md="4" class="text-caption text--secondary">
            {{ $t("day_after_limit") }}
          </v-col>
        </v-row>

        <v-sheet v-for="day in weekDays" :key="day.key" class="time-strip" outlined>
          <v-row dense align="center">
            <v-col cols="12" md="2" class="font-weight-medium">
              {{ day.label }}
            </v-col>
            <v-col cols="12" md="3">
              <text-field
                type="number"
                v-model="settings.days[day.key].day_before_limit"
                hide-details
                dense
              />
            </v-col>
            <v-col cols="12" md="3">
              <time-picker
                :value="getTimeString(day.key)"
                label=""
                :minute-interval="15"
                :hide-details="true"
                @input="setTimeString(day.key, $event)"
              />
            </v-col>
            <v-col cols="12" md="4">
              <text-field
                type="number"
                v-model="settings.days[day.key].day_after_limit"
                hide-details
                dense
              />
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TimePicker from "@/components/global/pickers/TimePicker.vue";

export default {
  name: "RestaurantTimeSettingsSection",
  components: {
    TimePicker,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    weekDays() {
      return [
        { key: "monday", label: this.$t("monday") },
        { key: "tuesday", label: this.$t("tuesday") },
        { key: "wednesday", label: this.$t("wednesday") },
        { key: "thursday", label: this.$t("thursday") },
        { key: "friday", label: this.$t("friday") },
        { key: "saturday", label: this.$t("saturday") },
        { key: "sunday", label: this.$t("sunday") },
      ];
    },
  },
  methods: {
    padTime(value) {
      if (value === null || value === undefined || value === "") return "";
      return String(value).padStart(2, "0");
    },
    getTimeString(dayKey) {
      if (!this.settings?.days?.[dayKey]) return "";
      const hours = this.settings.days[dayKey].time.time_hour;
      const minutes = this.settings.days[dayKey].time.time_minut;
      if (hours === "" || minutes === "") return "";
      return `${this.padTime(hours)}:${this.padTime(minutes)}`;
    },
    setTimeString(dayKey, value) {
      if (!this.settings?.days?.[dayKey]) return;
      if (!value) {
        this.settings.days[dayKey].time.time_hour = "";
        this.settings.days[dayKey].time.time_minut = "";
        return;
      }
      const [hours, minutes] = value.split(":");
      this.settings.days[dayKey].time.time_hour = this.padTime(hours || "");
      this.settings.days[dayKey].time.time_minut = this.padTime(minutes || "");
    },
    switchTimeStatus(type) {
      if (type === "old") {
        this.settings.old_time_changes = true;
        this.settings.new_time_changes = false;
      }
      if (type === "new") {
        this.settings.old_time_changes = false;
        this.settings.new_time_changes = true;
      }
    },
  },
};
</script>

<style scoped>
.time-strip {
  padding: 8px 12px;
  border-radius: 10px;
  margin-bottom: 8px;
  background: #fff;
}
.time-header {
  padding: 0 4px;
}
</style>
